<template>
  <v-icon :color="iconColor" v-bind="props">{{ icon }} </v-icon>
</template>

<script>
export default {
  name: "AlarmIcon",
  props: {
    state: [String, Number],
    props: Object,
  },
  data: () => ({
    names: {
      0: "warning",
      1: "error",
      2: "report",
    },
    colors: {
      0: "error",
      1: "warning",
      2: "accent",
    },
  }),
  computed: {
    icon() {
      const name = this.names[this.state];
      if (!name) {
        console.error(
          `${this._name} invalid state prop value: ${this.state}\n`,
          `Expected: [${Object.keys(this.names)}]`
        );
      }
      return name || "report_off";
    },

    iconColor() {
      return this.$vuetify.theme.themes.light[this.colors[this.state]]+'CC';
    },
  },
};
</script>

<style>
</style>